// export const STRIPE_ACCOUNT_ID = "stripeAccountId";
// export const STRIPE_ACCOUNT_COMPLETE = "stripeAccountComplete";
// export const STRIPE_LOGIN_URL = "stripeLoginUrl";
// export const INFLUENCER_CODE = "influencerCode";
export const ON_BOARD_SESSION = "onboardSession";

// export const createOnboardLoginSession = async (
//     userId,
//     username,
//     email,
//     accessToken,
//     refreshToken,
//     stripeAccountId,
//     stripeAccountComplete,
//     loginUrl,
//     influencerCode
// ) => {
//     //await localStorage.setItem(USER_ID_KEY, JSON.stringify(userId));
//     await localStorage.setItem(USER_ID_KEY, userId);
//     await localStorage.setItem(USER_NAME_KEY, username);
//     await localStorage.setItem(USER_EMAIL_KEY, email);
//     await localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
//     await localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
//     await localStorage.setItem(STRIPE_ACCOUNT_ID, stripeAccountId);
//     await localStorage.setItem(STRIPE_ACCOUNT_COMPLETE, stripeAccountComplete);
//     await localStorage.setItem(STRIPE_LOGIN_URL, loginUrl);
//     await localStorage.setItem(INFLUENCER_CODE, influencerCode);
//     await localStorage.setItem(ON_BOARD_SESSION, "true");
// };

// export const setIsStripeAccountComplete = async (
//     isStripeAccountComplete,
//     loginURL,
//     riCode
// ) => {
//     await localStorage.setItem(STRIPE_ACCOUNT_COMPLETE, isStripeAccountComplete);
//     await localStorage.setItem(STRIPE_LOGIN_URL, loginURL);
//     await localStorage.setItem(INFLUENCER_CODE, riCode);
// };
//
// export const isStripeAccountComplete = async () => {
//     try {
//         const stripeAccountComplete = localStorage.getItem(STRIPE_ACCOUNT_COMPLETE);
//         //debugger;
//         return stripeAccountComplete === "true" ? true : false;
//     } catch (error) {
//         // console.log("localStorage error on isLoggedIn: " + error.message);
//         return false;
//     }
// };

// export const getStripeOnboardAccountLoginUrl = async () => {
//     try {
//         const loginUrl = localStorage.getItem(STRIPE_LOGIN_URL);
//         return loginUrl;
//     } catch (error) {
//         // console.log("localStorage error on isLoggedIn: " + error.message);
//         return false;
//     }
// };
//
// export const getRiCode = async () => {
//     try {
//         const riCode = localStorage.getItem(INFLUENCER_CODE);
//         return riCode;
//     } catch (error) {
//         // console.log("localStorage error on isLoggedIn: " + error.message);
//         return false;
//     }
// };

// export const isOnboardLoggedIn = async () => {
//     try {
//         const token = localStorage.getItem(ACCESS_TOKEN_KEY);
//         const isOnboard = localStorage.getItem(ON_BOARD_SESSION);
//
//         const isLoggedIn = token && (isOnboard === "true");
//
//         return isLoggedIn;
//     } catch (error) {
//         return false;
//     }
// };
